import { Fragment } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import PersonSearch from 'shell/components/shared/person-search';
import { SearchPersonFactoCohabitationCrumbs } from 'mutation/constants/resolution-facto-cohabitation-crumbs';
import ActionsList from 'mutation/components/resolution-facto-cohabitation/actions-list';

const ResolutionFactoCohabitationSearchPage = (): React.ReactElement => {
  return (
    <Fragment>
      <Breadcrumbs items={SearchPersonFactoCohabitationCrumbs} />
      <PersonSearch
        pathname="/mutazioni/persona/risoluzione-convivenza-di-fatto/risoluzione"
        action={ActionsList}
        addedTitle={'- Risoluzione Convivenza di fatto'}
      />
    </Fragment>
  );
};

ResolutionFactoCohabitationSearchPage.displayName = 'Resolution Cohabitation Search page component';

export default ResolutionFactoCohabitationSearchPage;
